import { useState } from "react";

const SignatureUpload = ({ error,handleFileChange ,type}) => {

  return (
    <>
    <div className="flex items-center gap-2 border border-gray-300 p-2 rounded-md shadow-sm bg-white w-full  h-[55px]">

    <input
      type="file"
      accept="image/*"
      onChange={(e) => {
        handleFileChange(e, type)
      }}
      className="text-sm text-gray-700 cursor-pointer"
    />
  </div>
   {error && (
    <span>{error}</span>
  )}
  </>
  );
};

export default SignatureUpload;
